import React from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import websiteRemake from '../../../utilities/images/websiteRemake.png';
import WebsiteIcon from '../../../utilities/images/WebsiteIcon.png';
import ImageCarousel from './ImageCarousel';
import './Projects.css';
import { t } from 'i18next';
import SlideUpTransition from '../SlideUpTransition';
import ProjectActionButtons from './ProjectActionButtons';

interface WebsiteRemakeDialogProps {
    open: boolean;
    onClose: () => void;
}

const WebsiteRemakeDialog: React.FC<WebsiteRemakeDialogProps> = ({ open, onClose }) => {
    
  const isCompactScreen = useMediaQuery('(max-width: 768px)');
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isCompactScreen}
      TransitionComponent={SlideUpTransition}
      sx={{
        '& .MuiDialog-paper': {
          margin: isCompactScreen ? 0 : 2,
          width: isCompactScreen ? '100vw' : 'auto',
          maxWidth: isCompactScreen ? '100vw' : 'min(92vw, 960px)',
          maxHeight: isCompactScreen ? '100dvh' : '95dvh',
          borderRadius: isCompactScreen ? 0 : 3,
          overflow: isCompactScreen ? 'auto' : 'hidden',
        },
      }}
    >
      <div className="card">
        <IconButton aria-label="Close dialog" onClick={onClose} className="dialog-close-button" size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
        
        <div className="title">{t("projectDialogs.websiteRemake.title")}</div>
        
        <div className="card-content">
          <ImageCarousel images={[websiteRemake, WebsiteIcon]} alt={t("projectDialogs.websiteRemake.title")} />
          
          <div className="description">
            <div className="left-box">
              {t("projectDialogs.websiteRemake.description")}
            </div>
            
            <div className="right-box">
              <div>React</div>
              <div>TypeScript</div>
              <div>CSS</div>
              <div>Spline</div>
              <div>Firebase</div>
            </div>
          </div>
        </div>
        
        <ProjectActionButtons githubUrl="https://github.com/SirArchy/PersonalWebsiteRemake" />
      </div>
    </Dialog>
  );
};

export default WebsiteRemakeDialog;